import { render } from "./MpError.vue?vue&type=template&id=2011858f"
import script from "./MpError.vue?vue&type=script&lang=js"
export * from "./MpError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__